












import { Component, Prop, Vue, Emit } from 'vue-property-decorator';

@Component({})
export default class UsageClassSelector extends Vue {
  @Prop({default: null})
  private value!: string;

  @Prop({default: 'width: 155px;'})
  private styles!: string;

  @Prop({default: false})
  private disabled!: boolean;

  @Prop({default: true})
  private enableNoSelect!: boolean;

  @Emit('input')
  private update(event: Event): string | null {
    const target = event.target as HTMLInputElement;
    if (target.value) {
        return target.value as string;
    }
    return null;
  }
}
